<template>
  <v-container class="content">
    <h1>Riiqo Integrations</h1>
    <div class="mod-integrations">
      <div class="row">
        <div class="item item--shopify">
          <h5>Shopify</h5>
        </div>
        <div class="item item--woo">
          <h5>Woo</h5>
        </div>
        <div class="item item--stripe">
          <h5>Stripe</h5>
        </div>
        <div class="item item--paypal">
          <h5>Paypal</h5>
        </div>
        <div class="item item--square">
          <h5>Square</h5>
        </div>
        <div class="item item--slack">
          <h5>Slack</h5>
        </div>
        <div class="item item--qb">
          <h5>QB Finance</h5>
        </div>
        <div class="item item--qb">
          <h5>QB Products</h5>
        </div>
        <div class="item item--gcalendar">
          <h5>Google Calendar</h5>
        </div>
        <div class="item item--gmaps">
          <h5>Google Maps</h5>
        </div>
        <div class="item item--gsheets">
          <h5>Google Sheets</h5>
        </div>
        <div class="item item--gdocs">
          <h5>Google Docs</h5>
        </div>
        <div class="item item--ganalytics">
          <h5>Google Analytics</h5>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { bus } from '../../main'
export default {
  name: 'integrations',
  data: () => ({
    
  }),
  mounted () {
    console.log(this.$route);
    bus.$emit('update-route', this.$route);
  }
};
</script>
